import React, { useRef } from "react";
import Header from "./Header";
import emailjs from "@emailjs/browser";

const FormExample6 = () => {
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_o3zcoxx",
        "template_0qlo73c",
        form.current,
        "M5iZSLUHS1_XQ4bxD"
      )
      .then(
        (result) => {
          console.log(result.text);
          e.target.reset();
          alert("email sent successfulluly");
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div className="w-full h-auto flex flex-col items-center justify-center bg-primary  ">
      <Header />
      <div class="flex items-center justify-center w-full px-5 p-12">
        <div class="mx-auto w-full max-w-[480px]">
          <form
            action="https://formbold.com/s/FORM_ID"
            method="POST"
            ref={form}
            className="contact-form"
            onSubmit={sendEmail}
          >
            <div class="mb-5">
              <label
                for="name"
                class="mb-3 block text-base font-medium text-[#07074D]"
              >
                Full Name
              </label>
              <input
                type="text"
                name="your_name"
                id="name"
                placeholder="Full Name"
                class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
              />
            </div>
            <div class="mb-5">
              <label
                for="email"
                class="mb-3 block text-base font-medium text-[#07074D]"
              >
                Email Address
              </label>
              <input
                type="email"
                name="your_email"
                id="email"
                placeholder="example@gmail.com"
                class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
              />
            </div>
            {/* <div class="mb-5">
              <label
                for="subject"
                class="mb-3 block text-base font-medium text-[#07074D]"
              >
                Subject
              </label>
              <input
                type="text"
                name="subject"
                id="subject"
                placeholder="Enter your subject"
                class="w-full rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
              />
            </div> */}
            <div class="mb-5">
              <label
                for="message"
                class="mb-3 block text-base font-medium text-[#07074D]"
              >
                Message
              </label>
              <textarea
                rows="4"
                name="message"
                id="message"
                placeholder="Type your message"
                class="w-full resize-none rounded-md border border-[#e0e0e0] bg-white py-3 px-6 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
              ></textarea>
            </div>
            <div>
              <button
                type="submit"
                value="send"
                class=" flex flex-col  justify-center align-center  hover:shadow-form rounded-md bg-[#6A64F1] py-3 px-8 text-base font-semibold text-white outline-none"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FormExample6;
